import { useTheme } from '../context/ThemeContext';

/**
 * Hook simples para usar o controlador de tema
 */
export const useThemeController = () => {
  const { temaAtual, detectarTemaPorURL, setTemaAtual, TEMAS } = useTheme();

  return {
    temaAtual,
    detectarTemaPorURL,
    setTemaAtual, 
    TEMAS,
    isDixi: temaAtual === TEMAS.DIXI,
    isEvo: temaAtual === TEMAS.EVO,
    isTecnoponto: temaAtual === TEMAS.TECNOPONTO
  };
};

export default useThemeController;